/**
 * Which agent version a NEW AI-chat conversation runs on.
 *
 * Shared so the AI Chat page and the Reports "Ask AI" widget cannot drift. The
 * backend has no default of its own — ai/AIChat_v3/nodes/index.js derives
 * useReactAgent purely from what the frontend sends — so this is the only place
 * that decides.
 *
 * V2 everywhere, including prod. The AI Chat picker can still switch a new chat
 * back to V1; the widget has no picker and always gets the default. Existing
 * chats keep whatever version they were created with.
 */
export const getDefaultAgentVersion = () => "v2_reactAgent";
